import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import f1 from '../Resources/features1.png'
import f2 from '../Resources/features2.png'
import f3 from '../Resources/features3.png'
import f4 from '../Resources/features4.png'

import '../Styles/Features.css';
import features from '../Resources/feature.png';

export default function Features() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className='Sala-Features-Continer' id='features'>
      {/* Header Text Animation */}
      <div className='Sala-Features-Text-container' data-aos="zoom-in">
        <div className='Sala-Text-hr-line'></div>
        <h1>The Sala</h1>
      </div>

      {/* Subheading Animation */}
      <h1
        className='Sala-Features-h1'
        data-aos="fade-up"
        data-aos-delay="100"
      >
         These signature spaces are more than amenities — they’re touchpoints of culture, comfort, and connection.
      </h1>

      {/* Cards Container */}
      <div className='Sala-Features-cards-container'>
        {/* You can map real data here if needed */}
        <div className='Sala-cards-placer'>
        <div
          className='Sala-Features-card'
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <img src={f1} className='Sala-Features-card-icon' alt="feature icon" />
          <h1 className='Sala-Features-card-h1'>Sala Palace</h1>
          <p className='Sala-Features-card-p'>
            A majestic centerpiece inspired by royal Hoysala architecture — host gatherings, celebrate occasions, or simply marvel at the legacy in stone.
          </p>
          <button className='Sala-Features-card-btn'>→</button>
        </div>

        <div
          className='Sala-Features-card'
          data-aos="fade-up"
          data-aos-delay="350"
        >
          <img src={f2} className='Sala-Features-card-icon' alt="feature icon" />
          <h1 className='Sala-Features-card-h1'>Sala Kalyani</h1>
          <p className='Sala-Features-card-p'>
            An iconic stepwell echoing ancient serenity — the perfect setting for mindful moments, quiet strolls, or evening reflections.
          </p>
          <button className='Sala-Features-card-btn'>→</button>
        </div>
        </div>
        <div className='Sala-cards-placer'>
        <div
          className='Sala-Features-card'
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <img src={f3} className='Sala-Features-card-icon' alt="feature icon" />
          <h1 className='Sala-Features-card-h1'>Profit Sharing Villas </h1>
          <p className='Sala-Features-card-p'>
            A towering symbol of the Hoysala spirit — this sculptural landmark embodies the power, history, and pride that define the soul of Sala.
          </p>
          <button className='Sala-Features-card-btn'>→</button>
        </div>

        <div
          className='Sala-Features-card'
          data-aos="fade-up"
          data-aos-delay="650"
        >
          <img src={f4} className='Sala-Features-card-icon' alt="feature icon" />
          <h1 className='Sala-Features-card-h1'>Destination Wedding</h1>
          <p className='Sala-Features-card-p'>
            An unforgettable setting where vows are exchanged in history — designed for those who wish to begin forever with grandeur and grace.          </p>
          <button className='Sala-Features-card-btn'>→</button>
        </div>
        </div>

      </div>
    </div>
  );
}
